module.exports = __webpack_public_path__ + "img/comment_3_4.668006fb.jpg";